export const slideMediaConfig = {
	1400: { slidesPerView: 6 },
	1100: { slidesPerView: 5 },
	900: { slidesPerView: 4 },
	600: { slidesPerView: 3 },
	0: { slidesPerView: 2.2 }
};
